import { useFeatureValue } from '@growthbook/growthbook-react';
import { GrowthBookFeature } from '../model/experiment';
import { useUserType } from './useUserType';

export function useShowPayShipFeature() {
    try {
        const inExperiment_PAY_SHIP = useFeatureValue(GrowthBookFeature.PAY_SHIP, 'A') === 'B';
        const userType = useUserType();

        return userType === 'STANDARD' && inExperiment_PAY_SHIP;
    } catch (error) {
        console.warn('GrowthBook error, falling back to default:', error);
        return false;
    }
}
